/**
 * Created by forbiz on 2019-02-11.
 */
 
const applyOrderExchange = () => {
    const $document = $(document);

    const exChangeWay = () => {
        const $exchangeType = $('[name="exchangeType"]');

        $exchangeType
            .on('change', function() {
                const $this = $(this);
                const $wayBox = $('.exChnageWay');

                $exchangeType.attr('data-check', 'n');
                $this.attr('data-check', 'y');

                if ( $this.attr('id') == 'exchangeType01' ) {
                    $wayBox.eq(0).removeClass('hide');
                    $wayBox.eq(1).addClass('hide');
                } else {
                    $wayBox.eq(0).addClass('hide');
                    $wayBox.eq(1).removeClass('hide');
                }
            });
    };

    const dawnDelivery = () => {
        $document
            .on('change', '[name="VISIT_TYPE"]', function() {
                var $this = $(this);
                
                if ( $this.is(':checked') ) {
                    $('.dawnDelivery-info .hd-checkbox-type2').siblings('[type="text"]').css('visibility', 'hidden').val('');
                    $this.closest('.hd-checkbox-type2').siblings('[type="text"]').css('visibility', '');
            
                    if ( $('.infobox').find('.alertBox').length > 0 ) {
                        $('.infobox').find('.alertBox').remove();
                    }
                }
            });
    };

    const txtFileLoad = () => {
        $document.on('change', '.filebox input[type=file]', function() {
            const $this = $(this);
            const $srcInput = $this.closest('.filebox').find('input[type=text]');
            const _memory = Number($this.data('maxmemory-mb'));
            const _maxSize = _memory * 1024 * 1024; // MB 단위, KB일 경우 1024 한 개 제거
            const files = $this[0].files;
            let _thisSize = 0;

            if ( files && files[0] ) {
                if ( files[0].type.match(/(jpg|jpeg|png)/i) != null ) {
                    let reader = new FileReader();

                    _thisSize = files[0].size;
                    
                    if ( _thisSize >= _maxSize ) {
                        alert(`#{_memory}MB 미만의 파일만 등록 가능합니다.`);
                        $srcInput.val('');
                        $this.closest('.filebox').find('.file-delete').hide();
                    } else {
                        $this.closest('.filebox').find('.file-delete').show();
                        $srcInput.val(files[0].name);
                        reader.onload = function (e) {
                            $srcInput.next('input[type="hidden"]').val(e.target.result);
                        };
                        // $srcInput.val(files[0].name).next('input[type="hidden"]').val($this.val());
                    }
                    
                    reader.readAsDataURL(files[0]);
                } else {
                    alert('jpg 또는 png 파일만 등록 가능합니다.');
                    $srcInput.val('');
                    $this.closest('.filebox').find('.file-delete').hide();
                }
            } else {
                $srcInput.val('');
                $this.closest('.filebox').find('.file-delete').hide();
            }
        });

        $document.on('click', '.file-delete', function() {
            const $this = $(this);
            const $srcInput = $this.siblings('.input__file');
            const $fileInput = $this.closest('.filebox__view').siblings('label').find('input[type=file]');

            $srcInput.val('').next('input[type="hidden"]').val('');
            $fileInput.val('');
            $this.hide();

            return false;
        });
    };      

    const applyOrderExchangeInit = () => {
        exChangeWay();
        dawnDelivery();
        txtFileLoad();
    };

    applyOrderExchangeInit();
};

export default applyOrderExchange;